import FinanceSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class DepositSlip extends FinanceSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      hundredsCount: 0,
      fiftiesCount: 0,
      twentiesCount: 0,
      tensCount: 0,
      fivesCount: 0,
      coinsCount: 0,
      coinsAmount: 0,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    payload.coinsAmount = (payload.coinsAmount / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.coinsAmount = Math.round(hash.coinsAmount * 100);
    if (!isEmpty(hash.dailySummaryId)) {
      hash.dailySummaryId = parseInt(hash.dailySummaryId, 10);
    }
    return hash;
  }
}
